import { Transform } from "class-transformer";
import { IsBoolean, IsIn, IsNotEmpty, IsOptional } from "class-validator";
import { ConnectorTypes, CREATABLE_CONNECTOR_TYPES, IConnector } from "../../interfaces";

export class ConnectorDTO implements Partial<IConnector> {
  @IsNotEmpty({ message: 'Le nom du connecteur est requis' })
  name: string;

  @Transform((value) => !!value)
  @IsBoolean({ message: 'Le type envoyé n\'est pas correct' })
  autoPublish: boolean;

  @IsOptional()
  description: string;

}

export class ConnectorCreateDTO extends ConnectorDTO {
  @IsIn(CREATABLE_CONNECTOR_TYPES, { message: 'Le type du connecteur est requis' })
  type: ConnectorTypes;
}
